module.exports = __webpack_public_path__ + "static/76-about-metrics-2c13c0f5350326c22b6897a8680bdf36.png";